import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import ReportScreen from '../screen'

const ReportRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.REPORT} component={ReportScreen} />
        </React.Fragment>
    )
}

export default ReportRoutes